import { IGetItemsResult } from '~src/httpClient/serverApi/types/IGetItemsResult';

export interface CustomDomainSettingResponse extends IGetItemsResult {
  site_luid: string;
  custom_domain: string;
  intermediate_domain: string;
  status: string;
  request_initiation_date: Date;
  tls_certificate_uploaded_date: boolean;
  tls_certificate_expiry_date: Date;
}

export interface DeleteCustomDomainSettingRequest {
  site_luid: string;
}

export interface AddOrUpdateCustomDomainSettingRequest {
  site_luid: string;
  custom_domain: string;
  status: string;
  tls_certificate: string;
  tls_certificate_private_key: string;
}

export interface GetCustomDomainSettingRequest {
  site_luid: string;
}

export enum Status {
  requested = 'Requested',
  cnameVerificationRequested = 'CnameVerificationRequested',
  cnameVerificationInProgress = 'CnameVerificationInProgress',
  cnameVerificationFailed = 'CnameVerificationFailed',
  cnameVerificationSuccess = 'CnameVerificationSuccess',
  sslCertUploaded = 'SslCertUploaded',
  customDomainProvisioned = 'CustomDomainProvisioned'
}